/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiDataFromJSON, ApiDataToJSON, } from './ApiData';
import { ApiPageFromJSON, ApiPageToJSON, } from './ApiPage';
import { ApiProductBrandFromJSON, ApiProductBrandToJSON, } from './ApiProductBrand';
import { ApiProductCategoryFromJSON, ApiProductCategoryToJSON, } from './ApiProductCategory';
import { ApiProductNameFromJSON, ApiProductNameToJSON, } from './ApiProductName';
import { ApiProfitMarginFromJSON, ApiProfitMarginToJSON, } from './ApiProfitMargin';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
export function ApiProductFromJSON(json) {
    return ApiProductFromJSONTyped(json, false);
}
export function ApiProductFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'analyticsSynced': !exists(json, 'analyticsSynced') ? undefined : json['analyticsSynced'],
        'brand': !exists(json, 'brand') ? undefined : json['brand'],
        'category': !exists(json, 'category') ? undefined : json['category'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'displayPrice': !exists(json, 'displayPrice') ? undefined : json['displayPrice'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'imageUrl': !exists(json, 'imageUrl') ? undefined : json['imageUrl'],
        'marginsSynced': !exists(json, 'marginsSynced') ? undefined : (new Date(json['marginsSynced'])),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'pageViewImpressions': !exists(json, 'pageViewImpressions') ? undefined : (json['pageViewImpressions'].map(ApiDataFromJSON)),
        'pages': !exists(json, 'pages') ? undefined : (json['pages'].map(ApiPageFromJSON)),
        'price': !exists(json, 'price') ? undefined : json['price'],
        'productBrand': !exists(json, 'productBrand') ? undefined : ApiProductBrandFromJSON(json['productBrand']),
        'productBrandId': !exists(json, 'productBrandId') ? undefined : json['productBrandId'],
        'productCategory': !exists(json, 'productCategory') ? undefined : ApiProductCategoryFromJSON(json['productCategory']),
        'productCategoryId': !exists(json, 'productCategoryId') ? undefined : json['productCategoryId'],
        'productId': !exists(json, 'productId') ? undefined : json['productId'],
        'productName': !exists(json, 'productName') ? undefined : ApiProductNameFromJSON(json['productName']),
        'productNameId': !exists(json, 'productNameId') ? undefined : json['productNameId'],
        'profitMargins': !exists(json, 'profitMargins') ? undefined : (json['profitMargins'].map(ApiProfitMarginFromJSON)),
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'sku': !exists(json, 'sku') ? undefined : json['sku'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}
export function ApiProductToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'analyticsSynced': value.analyticsSynced,
        'brand': value.brand,
        'category': value.category,
        'description': value.description,
        'displayPrice': value.displayPrice,
        'id': value.id,
        'imageUrl': value.imageUrl,
        'marginsSynced': value.marginsSynced === undefined ? undefined : (value.marginsSynced.toISOString()),
        'name': value.name,
        'pageViewImpressions': value.pageViewImpressions === undefined ? undefined : (value.pageViewImpressions.map(ApiDataToJSON)),
        'pages': value.pages === undefined ? undefined : (value.pages.map(ApiPageToJSON)),
        'price': value.price,
        'productBrand': ApiProductBrandToJSON(value.productBrand),
        'productBrandId': value.productBrandId,
        'productCategory': ApiProductCategoryToJSON(value.productCategory),
        'productCategoryId': value.productCategoryId,
        'productId': value.productId,
        'productName': ApiProductNameToJSON(value.productName),
        'productNameId': value.productNameId,
        'profitMargins': value.profitMargins === undefined ? undefined : (value.profitMargins.map(ApiProfitMarginToJSON)),
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'sku': value.sku,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'url': value.url,
    };
}
